import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../pages/ExtraPages/firebaseConfig";
import Loader from "../Loader";

const ProtectedRoute = ({ element, allowedRoles }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userRole, setUserRole] = useState(null);

  // console.log(allowedRoles);

  useEffect(() => {
    const fetchUserRole = async (uid) => {
      console.log(uid);
      try {
        const response = await fetch(
          `https://api.starmarketapi.online/login_firebase/user-role/${uid}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch user role");
        }
        const data = await response.json();
        //console.log(data.role);
        setUserRole(data.role);
      } catch (error) {
        console.error("Error fetching user role:", error);
        setUserRole("unknown");
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
        fetchUserRole(user.uid);
      } else {
        setIsAuthenticated(false);
        setUserRole(null); // Ensure we reset userRole when logged out
      }
    });

    return () => unsubscribe();
  }, []);

  if (isAuthenticated === null) {
    //return <div>Loading...</div>; // Show loading while checking auth
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (userRole === null) {
    //return <div>Loading role...</div>; // Loading while fetching role
    return <Loader />;
  }

  if (
    allowedRoles &&
    !allowedRoles.some((role) => role.trim() === userRole.trim())
  ) {
    //return <Navigate to="/unauthorized" replace />;
    return <Navigate to="/error404" replace />;
  }

  return element;
};

export default ProtectedRoute;
